import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  TextInput,
  FlatList,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import Feather from "@expo/vector-icons/Feather";
import moment from "moment";
import { useIsFocused } from "@react-navigation/native";
import { useSelector } from "react-redux";
import ajax from "../../helpers/ajaxHelper";
import Urls from "../../services/Urls";
import { navigate } from "../../navigation/RootNavigation";
import WizardFooter from "./WizardFooter";
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard";

export const PropertySelectionStep = (props) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [properties, setProperties] = useState([]);
  const focused = useIsFocused();

  useEffect(() => {
    ajax
      .get(Urls.Properties)
      .then(({ data }) => {
        if (data.status) {
          setProperties(data?.payload || []);
        }
      })
      .catch((error) => console.log("error", error));

    setSelectedItem(null);
  }, [focused]);

  const startFlow = () => {
    if (!selectedItem) return;

    ajax
      .get(Urls.Search_FLOW + "/" + selectedItem)
      .then(({ data }) => {
        props.onNext({
          selectedProperty: properties.find(
            (p) => p.id === selectedItem
          ),
          existingFlows: data?.data || [],
        });
      })
      .catch((error) => console.log("error", error));
  };

  const filteredProperties = properties?.filter((item) =>
    item?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Properties</Text>
      <Text style={styles.subtitle}>
        Please search and select the property the tenant(s) will move into.
      </Text>

      <View style={styles.topRow}>
        <TextInput
          style={styles.searchInput}
          placeholder="Search"
          value={searchQuery}
          onChangeText={setSearchQuery}
        />


      </View>

      <FlatList
        data={filteredProperties}
        keyExtractor={(item) => item.id.toString()}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={[
              styles.row,
              selectedItem === item.id && styles.selectedRow,
            ]}
            onPress={() => setSelectedItem(item.id)}
          >
            <View
              style={[
                styles.checkbox,
                selectedItem === item.id &&
                  styles.selectedCheckbox,
              ]}
            >
              {selectedItem === item.id && (
                <Feather
                  name="check"
                  size={14}
                  color="white"
                />
              )}
            </View>

            <Text style={styles.cell}>{item.name}</Text>
            <Text style={styles.cell}>{item.postcode}</Text>
            <Text style={styles.cell}>
              {moment(item.updatedAt).format("YYYY-MM-DD")}
            </Text>
          </TouchableOpacity>
        )}
      />
<WizardFooter
  showLeft={false}
  rightLabel="Next"
  rightDisabled={!selectedItem}
  onRightPress={startFlow}
/>

    </View>
  );
};



const styles = StyleSheet.create({
  container: {
    padding: 15,
    backgroundColor: "#fff",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    color: COLORS.primary,
  },
  subtitle: {
    color: "gray",
    marginBottom: 15,
  },
  topRow: {
    flexDirection: "row",
    gap: 10,
    marginBottom: 20,
  },
  searchInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#ccc",
    padding: 8,
    borderRadius: 5,
  },
  button: {
    backgroundColor: "#7D57C1",
    paddingHorizontal: 15,
    justifyContent: "center",
    borderRadius: 5,
  },
  buttonText: {
    color: "#fff",
    fontWeight: "bold",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    borderBottomWidth: 1,
    borderColor: "#eee",
  },
  selectedRow: {
    backgroundColor: "#EEE4FF",
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 1,
    borderColor: "#7D57C1",
    marginRight: 10,
    borderRadius: 4,
  },
  selectedCheckbox: {
    backgroundColor: "#7D57C1",
    alignItems: "center",
    justifyContent: "center",
  },
  cell: {
    flex: 1,
    fontSize: 12,
  },
  continueButton: {
    flex: 1,
    backgroundColor: "#35b1c8",
    padding: 8,
    borderRadius: 6,
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 25,
  },
  startButton: {
    backgroundColor: "#7D57C1",
    padding: 10,
    borderRadius: 6,
  },
  backText: {
    color: "#d81b60",
    fontWeight: "600",
  },
  whiteText: {
    color: "#fff",
    textAlign: "center",
    fontWeight: "600",
  },
});
